<template>
  <div style="margin-bottom: 48px;">
    <year-month-filter-bar @change="searchFQC" ref="yearMonthFilterBar">
      <span>
        {{ querytype }}
        <i class="caret"></i>
        <select class="filter-item__select" v-model="querytype" @change="searchFQC">
          <option :value="'全部'">全部</option>
          <option :value="'产品'">产品</option>
          <option :value="'按工作中心'">按工作中心</option>
        </select>
      </span>
    </year-month-filter-bar>
    <!-- <search-bar
      @search="searchFQC"
      name=""
      placeholder="输入产品编号、名称、型号进行查找"
      ref="searchBar"
    /> -->
    <div class="weui-cells">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="(item, index) in list"
        :key="index"
        :to="{name: 'OutProductionFQCReportDetail', params: { item, querytype }}"
      >
        <div class="weui-cell__bd">
          <p v-if="querytype == '全部' || querytype == '产品'">{{item.pr_code}}</p>
          <p v-if="querytype == '按工作中心'">{{item.qc_wcname}}</p>
          <!-- <p class="list-item-muted">{{item.pr_detail}}</p> -->
        </div>
        <div class="weui-cell__ft">
          <p v-if="querytype == '全部' || querytype == '产品'">{{item.pr_detail}}</p>
          <!-- <p class="list-item-muted">{{item.pr_code}}</p> -->
        </div>
      </router-link>
    </div>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{list.length}}单</label>
    </div>
  </div>
</template>

<script>
// import SearchBar from "@/components/SearchBar.vue";
import YearMonthFilterBar from "@/components/YearMonthFilterBar.vue";

export default {
  components: {
    // SearchBar,
    YearMonthFilterBar
  },
  data() {
    return {
      list: [], // 品质FOQC检验明细列表
      querytype: "全部",
      querytypeObj: {
        全部: 'detail',
        产品: 'prod',
        按工作中心: 'workcenter',
      }
    }
  },
  mounted() {
    this.searchFQC()
  },
  methods: {
    searchFQC() {
      let me = this

      let yearmonth = me.$refs.yearMonthFilterBar.yearmonth

      // let keyword = me.$refs.searchBar.keyword

      let params = {
        yearmonth,
        querytype: me.querytypeObj[me.querytype]
      }
      // if(keyword) {
      //   if(me.querytype == "产品") {
      //     params.con = `pr_code = ${keyword}`
      //   } else if (me.querytype == "工作中心") {
      //     params.con = `ma_wcname like '%${keyword}%'`
      //   }
      // }

      me.$ajax({
        url: "/api/qc/report/fqc",
        params,
      }).then(function (res) {
        if (res.success) {
          me.list = res.data
        }
      });
    }
  }
}
</script>

<style scoped>
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option{
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
</style>